<template>
    <div class="PreviewNewswarp">
        <div class="leftbox">
            <div class="textbox">
                预览
            </div>
            <div @click="overperviewFn" class="btnbox">
                退出预览
            </div>

        </div>
        <div class="rightbox">
            <div class="title">
                {{formOdj.pressTopic}}
            </div>
            <div class="box2">
                <div>创建者(来源)：{{formOdj.pressSource}}</div>
                <div class="date">发布时间：{{formOdj.pressTime}}</div>
            </div>
            <div class="detail-newscontent" v-html="formOdj.content"></div>

        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            formOdj: {}
        }
    },
    created() {
        this.formOdj = JSON.parse(sessionStorage.getItem("formdata"))
    },
    methods: {
        overperviewFn() {
            // this.$router.push('/account-center/add-news');
			this.$router.go(-1)
        }
    }

}
</script>
<style lang="less" scoped>
.PreviewNewswarp {
	width: 100%;
	display: flex;
	flex-direction: row;
	box-sizing: border-box;
	padding: 55px 61px 0 50px;
	.leftbox {
		margin-right: 100px;
		.textbox {
			font-size: 24px;
			font-weight: bold;
			line-height: 24px;
			color: #43424b;
		}
		.btnbox {
			width: 143px;
			height: 42px;
			background: #ffb02c;
			opacity: 1;
			border-radius: 5px;
			color: #fff;
			text-align: center;
			line-height: 42px;
			cursor: pointer;
			margin-top: 42px;
		}
	}
	.rightbox {
		width: 70%;
		.title {
			font-size: 24px;
			line-height: 54px;
			color: #43424b;
			text-align: center;
		}
		.box2 {
			display: flex;
			flex-direction: row;
			font-size: 16px;
			line-height: 19px;
			color: #a6a9b7;
            border-bottom: 1px solid rgba(112, 112, 112, 0.12);
            padding-bottom: 10px;
			.date {
				margin-left: 42px;
			}
		}
		.detail-newscontent {
			/deep/img {
				width: 100%;
			}
			/deep/th,/deep/td{
				border: 1px solid #ccc;
				
			}
			/deep/th{
				border-bottom: none;
				background: #f1f1f1;
			}
		}
	}
}
</style>


